export const environment = {
  apiBaseUrl: 'https://xtsapi',
  imageBaseUrl: 'https://umisimages.s3.ap-south-1.amazonaws.com/Attachments/',
  apipublicUrl: 'https://umisapi.tnega.org', 
//  apipublicUrl: 'https://192.168.5.109/api',
  tokenEndPoint: '/api/token',
  production: true,
  environment: 'PROD',
  showEnvironment: false,
  indiaId: 83, //India Id used in student contact and student Info
};

// export const environment = {
//   apiBaseUrl: 'https://xtsapi',
//   imageBaseUrl: 'https://umisimages.s3.ap-south-1.amazonaws.com/Attachments/',
//    apipublicUrl: 'https://stagingtp.tnega.org/api',
//   //  apipublicUrl: 'https://localhost:6005',
//   // apipublicUrl: 'https://umisapi.tnega.org',


//   tokenEndPoint: '/api/token',
//   production: false,
//   environment: 'Local',
//   showEnvironment: true,
//   indiaId: 83, //India Id used in student contact and student Info
// };